'use client'

import DealsHero from './DealsHero'
import FilterableContainer from '@/components/content/common/FilterableContainer'
import DealThumbnail from '@/components/content/deals/root/DealThumbnail'
import { FeaturedPlacement } from '@/lib/analytics'
import { PageContextProvider } from '@/components/content/common/PageContext'
import { filterAndSortDeals } from '@/components/content/deals/helpers'
import type { FeaturedSection } from '@/types/app'
import type { Category, Deal } from '@/payload-types'

type DealsContainerProps = {
  deals: Deal[]
  dealsFeaturedTagSections: FeaturedSection[]
  categories: Category[]
}

export default function DealsContainer({
  deals,
  dealsFeaturedTagSections,
  categories,
}: DealsContainerProps) {
  return (
    <PageContextProvider scrollOffset={145}>
      <DealsHero deals={deals} />

      <FilterableContainer
        collection="deals"
        categories={categories}
        items={deals}
        featuredItems={dealsFeaturedTagSections}
        element={({
          item,
          type,
          index,
          total,
        }: {
          item: Deal
          type?: string
          index?: number
          total?: number
        }) => (
          <DealThumbnail
            deal={item}
            type={type}
            index={index}
            total={total}
            placement={FeaturedPlacement.DEALS_FEED}
          />
        )}
        filterItems={(items, filter) => filterAndSortDeals(items, filter.id)}
        cols={2}
      />
    </PageContextProvider>
  )
}
